module.exports = __webpack_public_path__ + "f0b9093ea0df08fb1f1064360478843c.svg";